<template>
  <div class="zhaopin" id="zhaopin">
    <v-app>
      <v-app-bar app color='primary' dark height="564" absolute>
        <v-row align="start">
          <!-- 一级导航栏 -->
          <FirstNavbar :tab_index="first_active_tab" :barHide="barHide" :barColor="barColor" :pc='pc'></FirstNavbar>
          <div class='first_title_box'  style="width:100%;height:calc(564px - 64px);" >
            <v-row align="center" justify="center">
              <v-col cols="12">
                <h1 class="first_title white--text">
                  加入我们
                </h1>
                <h4 class="body_text white--text">
                  <span>诚信</span><span>规范</span><span>创新</span><span>高效</span>
                </h4>
              </v-col>
            </v-row>
          </div>
          <!-- 首屏大图 -->
          <div style="width:100%;height:500px;position:absolute;z-index:-3;margin-left:-4px">
            <v-parallax height="564" dark src="../assets/images/bg_about.png">
            </v-parallax>
          </div>
        </v-row>
      </v-app-bar>
      <v-main>
        <div class="aboutContent">
          <v-row dense>
            <v-col cols="12">
              <BoxTitle firstTitle="加入我们" desc="加入福美，与我们一起探索科技世界" :index="1"></BoxTitle>
              <div class="contentBox">
                <div class="textBox">
                  <v-expansion-panels focusable v-model="panel">
                    <v-expansion-panel v-for="item in contentList" :key="item.index">
                      <v-expansion-panel-header>{{ item.zwmc }}</v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-list dense color="rgba(1,1,1,0)">
                          <p class="card_text">岗位职责：</p>
                          <v-list-item>
                            <v-list-item-content>
                              <p v-text="item.gwzz" class="card_text" style="letter-spacing:0"></p>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                        <v-list dense color="rgba(1,1,1,0)">
                          <p class="card_text">能力要求：</p>
                          <v-list-item>
                            <v-list-item-content>
                              <p v-text="item.nlyq" class="card_text" style="letter-spacing:0"></p>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                        <v-row align="center" justify="center">
                          <v-btn outlined href="http://erp.hbjxfm.com:8180/erp/f/resume/index" color="primary" target="_Blank" style="margin:10px" class='btn-blue'>投递简历</v-btn>
                          <!-- <v-btn outlined color="primary" class='btn-blue'>简历投递</v-btn> -->
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
              </div>
              <!-- 悬浮图标-回到顶部 -->
              <v-fab-transition>
                <v-btn
                  v-show="!floatHidden"
                  color="primary"
                  fixed
                  bottom
                  right
                  fab
                  @click="goTo(0)"
                >
                  <v-icon>mdi-arrow-up</v-icon>
                </v-btn>
              </v-fab-transition>
            </v-col>
          </v-row>
        </div>
      </v-main>
    <v-footer  color="secondary" style="height:auto">
      <FootContent :active="footList.active" :listWidth="footList.listWidth"></FootContent>
    </v-footer>
    </v-app>
  </div>
</template>

<script>
import FootContent from '../components/footer.vue'
import FirstNavbar from '../components/first-navbar.vue'
import BoxTitle from '../components/box-title.vue'

export default {
  name: 'zhaopin',
  components: {
    FootContent,
    FirstNavbar,
    BoxTitle
  },
  data: () => ({
    // 导航背景颜色
    barColor: 'rgba(63, 81, 181,0)',
    // 导航栏是否隐藏
    barHide: true,
    // 是否为PC端
    pc: false,
    // 悬浮按钮是否隐藏
    floatHidden: true,
    // 一级导航选项卡
    first_active_tab: 6,
    // 页脚参数
    footList: {
      listWidth: '10rem',
      active: [true, true, true]
    },
    // 列表激活项
    panel: 0,
    contentList: []
  }),
  mounted () {
    this.goTo(0)
    this.getData()
    var that = this
    that.whatScreen()
    // 屏幕尺寸监听
    window.onresize = function () {
      that.whatScreen()
    }
  },
  methods: {
  // 屏幕
    whatScreen () {
      var width = document.querySelector('html').offsetWidth
      if (width <= 768) {
        // title.innerHTML = "极小屏幕-" + width
        this.footList.active = [false, false, false]
        this.footList.listWidth = '90rem'
        this.pc = false
      } else {
        if (width > 768 && width <= 992) {
          // title.innerHTML = "小屏幕-" + width
          this.footList.active = [true, true, true]
          this.footList.listWidth = '10rem'
          this.pc = false
        } else {
          if (width > 992 && width <= 1100) {
            // title.innerHTML = "普通屏幕-" + width
            this.footList.active = [true, true, true]
            this.footList.listWidth = '10rem'
            this.pc = true
          } else {
            if (width > 1200 && width <= 1600) {
              // title.innerHTML = "大屏幕-" + width
              this.footList.active = [true, true, true]
              this.footList.listWidth = '10rem'
              this.pc = true
            } else {
              if (width > 1600) {
                // title.innerHTML = "大屏幕-" + width
                this.footList.listWidth = '10rem'
                this.footList.active = [true, true, true]
                this.pc = true
              }
            }
          }
        }
      }
    },
    // 一级导航跳转定位
    toguid (path_, id) {
      const path = path_
      const Id = id
      localStorage.setItem('toId', Id)
      this.$router.push(path)
    },
    goTo (ele) {
      document.body.scrollTop = ele
      document.documentElement.scrollTop = ele
    },
    // 获取招聘信息列表
    async getData () {
      const { data: res } = await this.$axios.post('erp/f/web/getZpInforList')
      this.contentList = res
    }
  }

}
</script>

<style>

</style>
